interface ModalParams {
    zindex?: number;
    open?: boolean;
    size?: 'sm' | 'md' | 'lg';
    closeable?: boolean;
    header?: string;
    subHeader?: string;
    textAlign?: 'left' | 'center' | 'right';
    overlayIndex?: number;
    trigger?: string | undefined;
}

interface ToastParams {
    show?: boolean;
    type?: 'success' | 'info' | 'warning' | 'error';
    showIcon?: boolean;
    header?: string;
    subHeader?: string;
    duration?: number;
    dRemove?: boolean;
    showClose?: boolean;
    isCard?: boolean;
}


export function Modal(params: ModalParams) {
    const modal: any = document.createElement("jackery-modal");
    const {
        zindex = 999,
        open,
        size = 'md',
        closeable,
        header,
        subHeader,
        textAlign,
        overlayIndex,
        trigger
    } = params

    modal.zindex = zindex
    modal.open = open
    modal.size = size
    modal.closeable = closeable
    modal.header = header
    modal.subHeader = subHeader
    modal.textAlign = textAlign
    modal.overlayIndex = overlayIndex
    modal.trigger = trigger
    document.body.appendChild(modal);

    return modal
}

let toast = null;
export async function Toast(params: ToastParams) {
    const {
        show = false,
        type = 'info',
        showIcon = true,
        header = '',
        subHeader = '',
        duration = 5000,
        dRemove = true,
        showClose = false,
        isCard = false
    } = params
    let mountToast = null;
    if (!toast) {
        toast = document.createElement("jackery-toast");
        mountToast = toast;
    } else {
        mountToast = toast;
    }
    if (mountToast.timer) clearTimeout(mountToast.timer);
    mountToast.show = show
    mountToast.type = type
    mountToast.showIcon = showIcon
    mountToast.header = header
    mountToast.subHeader = subHeader
    mountToast.duration = duration
    mountToast.dRemove = dRemove
    mountToast.showClose = showClose
    mountToast.isCard = isCard
    document.body.appendChild(mountToast);
    setTimeout(() => {mountToast.open()}, 0);

    if(duration !== 0) {
        mountToast.timer = setTimeout(() => {
            mountToast.show = false;
        }, duration);
    }
    return mountToast
}

(window as any)._modal = Modal;
(window as any)._toast = Toast;